import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IViewDetail } from '../types/IView';

export interface IGetViewByPathParams {
  path: string;
}

// The ViewDetail should be a property of the result, not the type of the result object itself.
export interface IGetViewByPathResult extends IResult, IViewDetail {
}

export class GetViewByPathRequest extends Request<IGetViewByPathParams, IGetViewByPathResult> {
  constructor(path: string) {
    super('getViewByPath', { path: path });
  }
}
